/* unplugin-vue-components disabled */import script from "./AlternatingMarquee.vue?vue&type=script&setup=true&lang=js"
export * from "./AlternatingMarquee.vue?vue&type=script&setup=true&lang=js"

import "./AlternatingMarquee.vue?vue&type=style&index=0&id=238f92cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-238f92cc"]])

export default __exports__